import { render } from "./dictAreaForm.vue?vue&type=template&id=4b03f232"
import script from "./dictAreaForm.vue?vue&type=script&lang=js"
export * from "./dictAreaForm.vue?vue&type=script&lang=js"

import "./dictAreaForm.vue?vue&type=style&index=0&id=4b03f232&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__